import { type Event } from '@sentry/types';
import { sendLog } from './logs';

/**
 * Uncaught errors thrown inside `blob:` web workers (e.g. third-party SDK workers) that
 * `isLogOnlyWorkerError` accepts go only to the logs at debug level: the event is dropped from the
 * error tracker and nothing is printed to the console (which the tracker would keep as a breadcrumb).
 * Every other event is returned untouched.
 */
export const sendWorkerErrorToLogs = (
    event: Event,
    isLogOnlyWorkerError: (message: string) => boolean,
): Event | null => {
    const exception = event.exception?.values?.[0];
    const frames = exception?.stacktrace?.frames ?? [];
    const frame = frames[frames.length - 1];
    const message = exception?.value ?? '';

    if (
        exception?.mechanism?.type !== 'onerror' ||
        !frame?.filename?.startsWith('blob:') ||
        !isLogOnlyWorkerError(message)
    ) {
        return event;
    }

    sendLog('debug', message, { workerPosition: `${frame.lineno}:${frame.colno}` });

    return null;
};
